import { render, staticRenderFns } from "./AutoWidthOption.vue?vue&type=template&id=86000a1a"
import script from "./AutoWidthOption.vue?vue&type=script&lang=ts"
export * from "./AutoWidthOption.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports